import { render, staticRenderFns } from "./poste-aim-btn.vue?vue&type=template&id=167c053f"
import script from "./poste-aim-btn.vue?vue&type=script&lang=js"
export * from "./poste-aim-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports